import { makeStyles } from '@mui/styles'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    flexDirection: 'column',
    paddingBottom: 20,
  },

  pageHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#EFEFEF',
    width: '100%',
    height: '100px',
    padding: '0 30px',
    marginBottom: 20,
    fontSize: 14,
  },

  dataTable: {
    borderCollapse: 'collapse',
    backgroundColor: '#FFFFFF',
    boxShadow:
        '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    borderRadius: 4,
    width: '95%',

    '& thead tr': {
        backgroundColor: theme.palette.primary.main,
        color: '#FFFFFF',
        textTransform: 'uppercase',

        '& th': {
            padding: 10,
            textAlign: 'center',
            fontSize: 10,
            width: 120,

            '&:first-child': {
                borderRadius: '4px 0 0 0',
            },

            '&:last-child': {
                borderRadius: '0 4px 0 0',
            },
        },
    },

    '& tbody tr': {
        borderBottom: '1px solid rgba(224, 224, 224, 1)',

        '&:hover': {
            backgroundColor: '#EDEDED',
        },

        '& td': {
            padding: 10,
            fontSize: 14,
            textAlign: 'center',
            cursor: 'pointer',
        },

        '& td:nth-child(-n+6)': {
          width: 300,
        },
    },

    '& tfoot tr': {
        '& td': {
            padding: 10,
        },
    },
  },

  modal: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    minHeight: 150,
    borderRadius: '10px',
    width: '80%',
    padding: '50px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
  },
}))

export default styles
